export default __webpack_public_path__ + "static/media/PEGI_7.d7b782c8.svg";